module.exports = __webpack_public_path__ + "img/capability-slider-img-6.d6d44fe4.png";